import { graphql } from '@/gql';
import type { RefundCustomChargeCostsMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const refundCustomChargeCosts = async ({
  payerType,
  amount,
  id,
  notes,
  refundAsCredits,
}: RefundCustomChargeCostsMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      payerType,
      amount: Number(amount),
      id,
      notes,
      refundAsCredits,
    },
    mutation: graphql(`
      mutation RefundCustomChargeCosts($notes: String!, $payerType: String!, $amount: Float!, $id: String!, $refundAsCredits: Boolean) {
        refundCustomChargeCosts(notes: $notes, payerType: $payerType, amount: $amount, id: $id, refundAsCredits: $refundAsCredits)
      }
    `),
  });

  return response.data?.refundCustomChargeCosts ?? '';
};
